export enum AnalyticsEventType {
    ConversationCreated = "ConversationCreated",
    MessageSent = "MessageSent",
    PinAdded = "PinAdded",
    PinRemoved = "PinRemoved",
    CallStarted = "CallStarted",
    NoteAdded = "NoteAdded"
}
